import { render, staticRenderFns } from "./chanyesuggest.vue?vue&type=template&id=5d4e973c&scoped=true"
import script from "./chanyesuggest.vue?vue&type=script&lang=js"
export * from "./chanyesuggest.vue?vue&type=script&lang=js"
import style0 from "./chanyesuggest.vue?vue&type=style&index=0&id=5d4e973c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4e973c",
  null
  
)

export default component.exports